// Strict email validator — use it for SIGN-UP only (new addresses).
// The old /^[^\s@]+@[^\s@]+\.[^\s@]+$/ accepted anything that wasn't a space
// or "@" — e.g. "kajal@yopmail,,,,.com". This one only allows:
//   local part : letters, digits and the RFC 5322 "atext" symbols
//                ! # $ % & ' * + / = ? ^ _ ` { | } ~ - in dot-separated runs
//                (no leading/trailing/double dots)
//   domain     : dot-separated labels of letters/digits/hyphens (a label
//                can't start or end with "-"), ending in a 2+ letter TLD or
//                a punycode TLD such as .xn--p1ai
const EMAIL_RE =
  /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+(?:[A-Za-z]{2,}|xn--[A-Za-z0-9-]*[A-Za-z0-9])$/;

// No trimming: the forms send the raw input to the API, so surrounding
// spaces must fail validation here (as they did before) rather than slip
// through and be rejected by the backend.
export const isValidEmail = (value) => {
  const email = String(value || "");
  return email.length <= 254 && EMAIL_RE.test(email);
};

// Permissive check for flows on EXISTING accounts (verify email, forgot /
// new / reset password). Accounts created before the strict check — or with
// internationalised addresses like josé@… or user@münchen.de — must still be
// able to recover; the backend decides whether the account exists.
const LOOSE_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isPlausibleEmail = (value) => LOOSE_EMAIL_RE.test(String(value || ""));

export default isValidEmail;
